export default (palette) => ({
  root: {
    // 📐 Engenharia Híbrida: Arredonda rigorosamente o topo e deixa a base reta para o footer! 🛰️🚀💎
    borderCollapse: 'separate !important',
    borderSpacing: '0 !important',
    borderRadius: '12px 12px 0 0', // Arredonda apenas as quinas superiores! 🧼✨
    overflow: 'hidden',
    border: `1px solid ${palette.divider}`,
    borderBottom: 'none', // Remove a barreira inferior para junção contígua perfeita!
    backgroundColor: 'transparent',
  },
})
